import { createClient } from '@supabase/supabase-js';

const SUPABASE_URL = process.env.REACT_APP_SUPABASE_URL;
const SUPABASE_ANON_KEY = process.env.REACT_APP_SUPABASE_ANON_KEY;

if (!SUPABASE_URL || !SUPABASE_ANON_KEY) {
  const errorMsg = 'CRITICAL ERROR: Supabase URL or Anon Key is missing. Check your .env file. App will not function correctly.';
  console.error(errorMsg);
  if (typeof window !== 'undefined') {
    alert(errorMsg);
  }
}

const supabase = createClient(SUPABASE_URL, SUPABASE_ANON_KEY);

if (typeof window !== 'undefined') {
  window.supabase = supabase;
}

export default supabase;
